module.exports = __webpack_public_path__ + "assets/farming-right.8657023c.svg";